import environment from "../environment";
import { GETWithParams, POST } from "./http.service";

export const getAllActivities = async (requestParams) => {
  const response = await GETWithParams(
    `Workshop`,
    requestParams,
    localStorage.getItem(environment.TOKEN_KEY)
  );
  return response;
};

export const applyActivity = async (id) => {
  const response = await POST(
    `Workshop/${id}/apply`,
    null,
    localStorage.getItem(environment.TOKEN_KEY)
  );
  return response;
};
